module.exports = __webpack_public_path__ + "static/media/inf_01og02.efcb0267.mp3";